import ScrollReveal from '@/components/base/ScrollReveal';

const principles = [
  {
    icon: 'ri-focus-3-line',
    title: 'We start with the pain point.',
    description:
      'Before writing code, we understand what decision the system needs to drive, and why.',
  },
  {
    icon: 'ri-stack-line',
    title: 'We build to last.',
    description:
      'Clean architecture and easy handover, so your team can own and run the software for the long haul.',
  },
  {
    icon: 'ri-group-line',
    title: 'We stay close.',
    description:
      'One team, direct contact, with you from the first line of code.',
  },
];

export default function VisionMissionSection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 lg:px-16 bg-background-50 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-14 md:mb-18">
          <ScrollReveal delay={200}>
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-primary-800 leading-[1.12] tracking-tight">
              How We <span className="text-accent-500">Work</span>
            </h2>
          </ScrollReveal>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {principles.map((p, i) => (
            <ScrollReveal key={p.title} delay={i * 150}>
              <div className="group relative bg-background-50 rounded-2xl p-8 border border-background-200 hover:border-accent-500/30 hover:-translate-y-1.5 hover:bg-background-50/80 transition-all duration-400 h-full flex flex-col">
                {/* Left accent bar */}
                <div className="absolute left-0 top-8 bottom-8 w-[3px] rounded-r-full bg-accent-500/30 group-hover:bg-accent-500 group-hover:w-1 transition-all duration-400"></div>

                {/* Top accent bar on hover */}
                <div className="absolute top-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-accent-500/0 group-hover:via-accent-500/30 to-transparent transition-all duration-500"></div>

                {/* Icon circle */}
                <div className="w-12 h-12 rounded-xl bg-accent-500/8 flex items-center justify-center mb-6 group-hover:bg-accent-500/15 group-hover:scale-110 group-hover:rounded-2xl transition-all duration-400">
                  <i className={`${p.icon} text-accent-500 text-xl group-hover:text-accent-600 transition-colors duration-400`}></i>
                </div>

                {/* Content */}
                <h3 className="font-heading font-semibold text-lg text-primary-800 mb-3 group-hover:text-primary-900 transition-colors duration-400">
                  {p.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {p.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}